import React from 'react';
import { CheckCircleIcon, TruckIcon, PackageIcon } from 'lucide-react';
interface OrderConfirmationProps {
  orderNumber: string;
  shippingInfo: {
    firstName: string;
    lastName: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
}
export const OrderConfirmation: React.FC<OrderConfirmationProps> = ({
  orderNumber,
  shippingInfo
}) => {
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6" data-id="element-91">
      <div className="text-center" data-id="element-92">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6" data-id="element-93">
          <CheckCircleIcon className="h-10 w-10 text-green-600" aria-hidden="true" data-id="element-94" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-95">
          Thank you for your order!
        </h2>
        <p className="text-lg text-gray-700 mb-6" data-id="element-96">
          Your order has been placed and is being processed.
        </p>
        <p className="text-gray-600 mb-4" data-id="element-97">
          We've sent a confirmation email to{' '}
          <span className="font-medium" data-id="element-98">{shippingInfo.email}</span> with your
          order details.
        </p>
        <div className="border border-gray-200 rounded-md p-4 bg-gray-50 mb-6 mx-auto max-w-md" data-id="element-99">
          <p className="text-sm text-gray-700 mb-1" data-id="element-100">Order number:</p>
          <p className="text-lg font-bold text-fuchsia-600 mb-3" data-id="element-101">
            {orderNumber}
          </p>
          <p className="text-sm text-gray-700 mb-1" data-id="element-102">Shipping to:</p>
          <p className="text-sm text-gray-900" data-id="element-103">
            {shippingInfo.firstName} {shippingInfo.lastName}
            <br data-id="element-104" />
            {shippingInfo.address}
            <br data-id="element-105" />
            {shippingInfo.city}, {shippingInfo.state} {shippingInfo.zipCode}
            <br data-id="element-106" />
            {shippingInfo.country}
          </p>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-107">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-108">
            What happens next?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-109">
            <div className="flex flex-col items-center" data-id="element-110">
              <div className="bg-fuchsia-100 p-3 rounded-full mb-3" data-id="element-111">
                <PackageIcon className="h-6 w-6 text-fuchsia-600" data-id="element-112" />
              </div>
              <h4 className="font-medium text-gray-900 mb-1" data-id="element-113">
                Order Processing
              </h4>
              <p className="text-sm text-gray-500" data-id="element-114">
                We're preparing your items for shipment
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-115">
              <div className="bg-fuchsia-100 p-3 rounded-full mb-3" data-id="element-116">
                <TruckIcon className="h-6 w-6 text-fuchsia-600" data-id="element-117" />
              </div>
              <h4 className="font-medium text-gray-900 mb-1" data-id="element-118">Shipping</h4>
              <p className="text-sm text-gray-500" data-id="element-119">
                Your order will be on its way to you soon
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-120">
              <div className="bg-fuchsia-100 p-3 rounded-full mb-3" data-id="element-121">
                <CheckCircleIcon className="h-6 w-6 text-fuchsia-600" data-id="element-122" />
              </div>
              <h4 className="font-medium text-gray-900 mb-1" data-id="element-123">Delivery</h4>
              <p className="text-sm text-gray-500" data-id="element-124">
                Estimated arrival in 7-10 business days
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8" data-id="element-125">
          <a href="/" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-600 hover:bg-fuchsia-700" data-id="element-126">
            Continue Shopping
          </a>
        </div>
      </div>
    </div>;
};